import { z } from 'zod';

import { IdSchema, PythonicNameSchema } from '../../base';
import { variablesReferencesAdapter } from './variables.adapters';
import { VariableReferencesSchema } from './variables.schema';

export const CreateVariableSchema = z
  .object({
    id: IdSchema,
    name: PythonicNameSchema,
    references: VariableReferencesSchema.default(() =>
      variablesReferencesAdapter.createInitialState(),
    ),
  })
  .describe(
    'Create a new variable to store computed or system-set values accessible via conv.state in function code',
  );

export const UpdateVariableSchema = z
  .object({
    id: IdSchema,
    name: PythonicNameSchema.optional(),
    references: VariableReferencesSchema.optional(),
    oldName: PythonicNameSchema.optional().describe(
      'Previous variable name, enables updating conv.state references in function code when renamed',
    ),
  })
  .describe("Update a variable's properties");

export const DeleteVariableSchema = z
  .object({
    id: IdSchema,
  })
  .describe('Delete a variable by its ID');

export type CreateVariablePayload = z.infer<typeof CreateVariableSchema>;

export type DeleteVariablePayload = z.infer<typeof DeleteVariableSchema>;

export type UpdateVariablePayload = z.infer<typeof UpdateVariableSchema>;
